//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class DocumentsIsoClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkTextStandards(body: CheckTextStandardsRequest | undefined, signal?: AbortSignal): Promise<CheckDocumentStandardsResponse> {
        let url_ = this.baseUrl + "/api/Documents/check-text-standards";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckTextStandards(_response);
        });
    }

    protected processCheckTextStandards(response: AxiosResponse): Promise<CheckDocumentStandardsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CheckDocumentStandardsResponse.fromJS(resultData200);
            return Promise.resolve<CheckDocumentStandardsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckDocumentStandardsResponse>(null as any);
    }

    /**
     * @param file (optional) 
     * @param selectedCategories (optional) 
     * @param selectedDate (optional) 
     * @return Success
     */
    checkStandards(file: FileParameter | undefined, selectedCategories: string[] | undefined, selectedDate: Date | undefined, signal?: AbortSignal): Promise<CheckDocumentStandardsResponse> {
        let url_ = this.baseUrl + "/api/Documents/check-standards";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (selectedCategories === null || selectedCategories === undefined)
            throw new Error("The parameter 'selectedCategories' cannot be null.");
        else
            selectedCategories.forEach(item_ => content_.append("SelectedCategories", item_.toString()));
        if (selectedDate === null || selectedDate === undefined)
            throw new Error("The parameter 'selectedDate' cannot be null.");
        else
            content_.append("SelectedDate", selectedDate.toJSON());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckStandards(_response);
        });
    }

    protected processCheckStandards(response: AxiosResponse): Promise<CheckDocumentStandardsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CheckDocumentStandardsResponse.fromJS(resultData200);
            return Promise.resolve<CheckDocumentStandardsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckDocumentStandardsResponse>(null as any);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    convertWordToPdf(file: FileParameter | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Documents/convert-word-to-pdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConvertWordToPdf(_response);
        });
    }

    protected processConvertWordToPdf(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param pdfFile (optional) 
     * @param replacementsJson (optional) 
     * @return Success
     */
    replaceInvalidOccurrences(pdfFile: FileParameter | undefined, replacementsJson: string | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Documents/replace-invalid-occurrences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (pdfFile === null || pdfFile === undefined)
            throw new Error("The parameter 'pdfFile' cannot be null.");
        else
            content_.append("PdfFile", pdfFile.data, pdfFile.fileName ? pdfFile.fileName : "PdfFile");
        if (replacementsJson === null || replacementsJson === undefined)
            throw new Error("The parameter 'replacementsJson' cannot be null.");
        else
            content_.append("ReplacementsJson", replacementsJson.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReplaceInvalidOccurrences(_response);
        });
    }

    protected processReplaceInvalidOccurrences(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class MeIsoClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    me(signal?: AbortSignal): Promise<MeResponse> {
        let url_ = this.baseUrl + "/api/Me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMe(_response);
        });
    }

    protected processMe(response: AxiosResponse): Promise<MeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MeResponse.fromJS(resultData200);
            return Promise.resolve<MeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MeResponse>(null as any);
    }

    /**
     * @return Success
     */
    keepAliveGET(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Me/keep-alive";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processKeepAliveGET(_response);
        });
    }

    protected processKeepAliveGET(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    keepAliveHEAD(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Me/keep-alive";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "HEAD",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processKeepAliveHEAD(_response);
        });
    }

    protected processKeepAliveHEAD(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class StandardsIsoClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    update(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Standards/update";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateManually(body: UpdateStandardsManuallyRequest | undefined, signal?: AbortSignal): Promise<UpdateStandardsManuallyResponse> {
        let url_ = this.baseUrl + "/api/Standards/updateManually";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateManually(_response);
        });
    }

    protected processUpdateManually(response: AxiosResponse): Promise<UpdateStandardsManuallyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateStandardsManuallyResponse.fromJS(resultData200);
            return Promise.resolve<UpdateStandardsManuallyResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateStandardsManuallyResponse>(null as any);
    }

    /**
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortField (optional) 
     * @param sortDirection (optional) 
     * @param filterField (optional) 
     * @param filterValue (optional) 
     * @param filterOperator (optional) 
     * @return Success
     */
    standards(pageIndex: number | undefined, pageSize: number | undefined, sortField: string | undefined, sortDirection: string | undefined, filterField: string | undefined, filterValue: string | undefined, filterOperator: string | undefined, signal?: AbortSignal): Promise<GetStandardsResponse> {
        let url_ = this.baseUrl + "/api/Standards/standards?";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField === null)
            throw new Error("The parameter 'sortField' cannot be null.");
        else if (sortField !== undefined)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (filterField === null)
            throw new Error("The parameter 'filterField' cannot be null.");
        else if (filterField !== undefined)
            url_ += "filterField=" + encodeURIComponent("" + filterField) + "&";
        if (filterValue === null)
            throw new Error("The parameter 'filterValue' cannot be null.");
        else if (filterValue !== undefined)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (filterOperator === null)
            throw new Error("The parameter 'filterOperator' cannot be null.");
        else if (filterOperator !== undefined)
            url_ += "filterOperator=" + encodeURIComponent("" + filterOperator) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStandards(_response);
        });
    }

    protected processStandards(response: AxiosResponse): Promise<GetStandardsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetStandardsResponse.fromJS(resultData200);
            return Promise.resolve<GetStandardsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetStandardsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    delete(body: DeleteStandardRequest | undefined, signal?: AbortSignal): Promise<DeleteStandardResponse> {
        let url_ = this.baseUrl + "/api/Standards/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<DeleteStandardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStandardResponse.fromJS(resultData200);
            return Promise.resolve<DeleteStandardResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStandardResponse>(null as any);
    }

    /**
     * @param file (optional) 
     * @param selectedCategories (optional) 
     * @param selectedDate (optional) 
     * @return Success
     */
    importStandardExcel(file: FileParameter | undefined, selectedCategories: string[] | undefined, selectedDate: Date | undefined, signal?: AbortSignal): Promise<ImportStandardExcelResponse> {
        let url_ = this.baseUrl + "/api/Standards/import-standard-excel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (selectedCategories === null || selectedCategories === undefined)
            throw new Error("The parameter 'selectedCategories' cannot be null.");
        else
            selectedCategories.forEach(item_ => content_.append("SelectedCategories", item_.toString()));
        if (selectedDate === null || selectedDate === undefined)
            throw new Error("The parameter 'selectedDate' cannot be null.");
        else
            content_.append("SelectedDate", selectedDate.toJSON());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportStandardExcel(_response);
        });
    }

    protected processImportStandardExcel(response: AxiosResponse): Promise<ImportStandardExcelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportStandardExcelResponse.fromJS(resultData200);
            return Promise.resolve<ImportStandardExcelResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportStandardExcelResponse>(null as any);
    }

    /**
     * @return Success
     */
    importCzechLawsBatch(signal?: AbortSignal): Promise<ImportCzechLawsResponse> {
        let url_ = this.baseUrl + "/api/Standards/import-czech-laws-batch";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportCzechLawsBatch(_response);
        });
    }

    protected processImportCzechLawsBatch(response: AxiosResponse): Promise<ImportCzechLawsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportCzechLawsResponse.fromJS(resultData200);
            return Promise.resolve<ImportCzechLawsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportCzechLawsResponse>(null as any);
    }

    /**
     * @return Success
     */
    importSkNormsBatch(signal?: AbortSignal): Promise<ImportSkNormsResponse> {
        let url_ = this.baseUrl + "/api/Standards/import-sk-norms-batch";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportSkNormsBatch(_response);
        });
    }

    protected processImportSkNormsBatch(response: AxiosResponse): Promise<ImportSkNormsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportSkNormsResponse.fromJS(resultData200);
            return Promise.resolve<ImportSkNormsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportSkNormsResponse>(null as any);
    }

    /**
     * @return Success
     */
    scrapeRsdTkp(signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Standards/scrape-rsd-tkp";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processScrapeRsdTkp(_response);
        });
    }

    protected processScrapeRsdTkp(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    categories(signal?: AbortSignal): Promise<GetAllCategoriesResponse> {
        let url_ = this.baseUrl + "/api/Standards/categories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCategories(_response);
        });
    }

    protected processCategories(response: AxiosResponse): Promise<GetAllCategoriesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllCategoriesResponse.fromJS(resultData200);
            return Promise.resolve<GetAllCategoriesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllCategoriesResponse>(null as any);
    }
}

export class CheckDocumentStandardsResponse implements ICheckDocumentStandardsResponse {
    ok?: boolean;
    invalidStandards?: InvalidStandardOccurrence[] | undefined;
    convertedPdfStream?: Stream;

    constructor(data?: ICheckDocumentStandardsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            if (Array.isArray(_data["invalidStandards"])) {
                this.invalidStandards = [] as any;
                for (let item of _data["invalidStandards"])
                    this.invalidStandards!.push(InvalidStandardOccurrence.fromJS(item));
            }
            this.convertedPdfStream = _data["convertedPdfStream"] ? Stream.fromJS(_data["convertedPdfStream"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CheckDocumentStandardsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CheckDocumentStandardsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        if (Array.isArray(this.invalidStandards)) {
            data["invalidStandards"] = [];
            for (let item of this.invalidStandards)
                data["invalidStandards"].push(item.toJSON());
        }
        data["convertedPdfStream"] = this.convertedPdfStream ? this.convertedPdfStream.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICheckDocumentStandardsResponse {
    ok?: boolean;
    invalidStandards?: InvalidStandardOccurrence[] | undefined;
    convertedPdfStream?: Stream;
}

export class CheckTextStandardsRequest implements ICheckTextStandardsRequest {
    text?: string | undefined;
    selectedCategories?: string[] | undefined;
    selectedDate?: Date | undefined;

    constructor(data?: ICheckTextStandardsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            if (Array.isArray(_data["selectedCategories"])) {
                this.selectedCategories = [] as any;
                for (let item of _data["selectedCategories"])
                    this.selectedCategories!.push(item);
            }
            this.selectedDate = _data["selectedDate"] ? new Date(_data["selectedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CheckTextStandardsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckTextStandardsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        if (Array.isArray(this.selectedCategories)) {
            data["selectedCategories"] = [];
            for (let item of this.selectedCategories)
                data["selectedCategories"].push(item);
        }
        data["selectedDate"] = this.selectedDate ? this.selectedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICheckTextStandardsRequest {
    text?: string | undefined;
    selectedCategories?: string[] | undefined;
    selectedDate?: Date | undefined;
}

export class DeleteStandardRequest implements IDeleteStandardRequest {
    id?: number;

    constructor(data?: IDeleteStandardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteStandardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteStandardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteStandardRequest {
    id?: number;
}

export class DeleteStandardResponse implements IDeleteStandardResponse {
    success?: boolean;

    constructor(data?: IDeleteStandardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): DeleteStandardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteStandardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IDeleteStandardResponse {
    success?: boolean;
}

export class FontInfo implements IFontInfo {
    fontName?: string | undefined;
    fontSize?: number;
    isBold?: boolean;
    isItalic?: boolean;
    color?: string | undefined;

    constructor(data?: IFontInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fontName = _data["fontName"];
            this.fontSize = _data["fontSize"];
            this.isBold = _data["isBold"];
            this.isItalic = _data["isItalic"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): FontInfo {
        data = typeof data === 'object' ? data : {};
        let result = new FontInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fontName"] = this.fontName;
        data["fontSize"] = this.fontSize;
        data["isBold"] = this.isBold;
        data["isItalic"] = this.isItalic;
        data["color"] = this.color;
        return data;
    }
}

export interface IFontInfo {
    fontName?: string | undefined;
    fontSize?: number;
    isBold?: boolean;
    isItalic?: boolean;
    color?: string | undefined;
}

export class GetAllCategoriesResponse implements IGetAllCategoriesResponse {
    categories?: string[] | undefined;

    constructor(data?: IGetAllCategoriesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(item);
            }
        }
    }

    static fromJS(data: any): GetAllCategoriesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllCategoriesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        return data;
    }
}

export interface IGetAllCategoriesResponse {
    categories?: string[] | undefined;
}

export class GetStandardsResponse implements IGetStandardsResponse {
    standards?: StandardDto[] | undefined;
    lastUpdated?: Date | undefined;
    totalCount?: number;

    constructor(data?: IGetStandardsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["standards"])) {
                this.standards = [] as any;
                for (let item of _data["standards"])
                    this.standards!.push(StandardDto.fromJS(item));
            }
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : <any>undefined;
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): GetStandardsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStandardsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.standards)) {
            data["standards"] = [];
            for (let item of this.standards)
                data["standards"].push(item.toJSON());
        }
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IGetStandardsResponse {
    standards?: StandardDto[] | undefined;
    lastUpdated?: Date | undefined;
    totalCount?: number;
}

export class ImportCzechLawsResponse implements IImportCzechLawsResponse {

    constructor(data?: IImportCzechLawsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ImportCzechLawsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportCzechLawsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IImportCzechLawsResponse {
}

export class ImportSkNormsResponse implements IImportSkNormsResponse {

    constructor(data?: IImportSkNormsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ImportSkNormsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportSkNormsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IImportSkNormsResponse {
}

export class ImportStandardExcelResponse implements IImportStandardExcelResponse {
    ok?: boolean;

    constructor(data?: IImportStandardExcelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): ImportStandardExcelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportStandardExcelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IImportStandardExcelResponse {
    ok?: boolean;
}

export class InvalidStandardOccurrence implements IInvalidStandardOccurrence {
    id?: number;
    identificator?: string | undefined;
    pageNumber?: number;
    paragraphText?: string | undefined;
    validToString?: string | undefined;
    validTo?: Date | undefined;
    x?: number;
    y?: number;
    width?: number;
    height?: number;
    wordStartPosition?: number | undefined;
    wordEndPosition?: number | undefined;
    wordRangeText?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    validStandards?: ValidStandard[] | undefined;
    detailUrl?: string | undefined;
    anotation?: string | undefined;
    fontInfo?: FontInfo;

    constructor(data?: IInvalidStandardOccurrence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identificator = _data["identificator"];
            this.pageNumber = _data["pageNumber"];
            this.paragraphText = _data["paragraphText"];
            this.validToString = _data["validToString"];
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            this.x = _data["x"];
            this.y = _data["y"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.wordStartPosition = _data["wordStartPosition"];
            this.wordEndPosition = _data["wordEndPosition"];
            this.wordRangeText = _data["wordRangeText"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["validStandards"])) {
                this.validStandards = [] as any;
                for (let item of _data["validStandards"])
                    this.validStandards!.push(ValidStandard.fromJS(item));
            }
            this.detailUrl = _data["detailUrl"];
            this.anotation = _data["anotation"];
            this.fontInfo = _data["fontInfo"] ? FontInfo.fromJS(_data["fontInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InvalidStandardOccurrence {
        data = typeof data === 'object' ? data : {};
        let result = new InvalidStandardOccurrence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identificator"] = this.identificator;
        data["pageNumber"] = this.pageNumber;
        data["paragraphText"] = this.paragraphText;
        data["validToString"] = this.validToString;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        data["wordStartPosition"] = this.wordStartPosition;
        data["wordEndPosition"] = this.wordEndPosition;
        data["wordRangeText"] = this.wordRangeText;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.validStandards)) {
            data["validStandards"] = [];
            for (let item of this.validStandards)
                data["validStandards"].push(item.toJSON());
        }
        data["detailUrl"] = this.detailUrl;
        data["anotation"] = this.anotation;
        data["fontInfo"] = this.fontInfo ? this.fontInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInvalidStandardOccurrence {
    id?: number;
    identificator?: string | undefined;
    pageNumber?: number;
    paragraphText?: string | undefined;
    validToString?: string | undefined;
    validTo?: Date | undefined;
    x?: number;
    y?: number;
    width?: number;
    height?: number;
    wordStartPosition?: number | undefined;
    wordEndPosition?: number | undefined;
    wordRangeText?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    validStandards?: ValidStandard[] | undefined;
    detailUrl?: string | undefined;
    anotation?: string | undefined;
    fontInfo?: FontInfo;
}

export class MeResponse implements IMeResponse {
    userName?: string | undefined;
    email?: string | undefined;
    apiUrl?: string | undefined;

    constructor(data?: IMeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.apiUrl = _data["apiUrl"];
        }
    }

    static fromJS(data: any): MeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["apiUrl"] = this.apiUrl;
        return data;
    }
}

export interface IMeResponse {
    userName?: string | undefined;
    email?: string | undefined;
    apiUrl?: string | undefined;
}

export class StandardDto implements IStandardDto {
    id?: number;
    identificator?: string | undefined;
    code?: string | undefined;
    efficiencyDate?: Date;
    validTo?: Date | undefined;
    name?: string | undefined;
    description?: string | undefined;
    katalog?: string | undefined;
    detailUrl?: string | undefined;
    anotation?: string | undefined;
    category?: string | undefined;
    subsequentStandards?: string | undefined;
    isEditable?: boolean;

    constructor(data?: IStandardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identificator = _data["identificator"];
            this.code = _data["code"];
            this.efficiencyDate = _data["efficiencyDate"] ? new Date(_data["efficiencyDate"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.description = _data["description"];
            this.katalog = _data["katalog"];
            this.detailUrl = _data["detailUrl"];
            this.anotation = _data["anotation"];
            this.category = _data["category"];
            this.subsequentStandards = _data["subsequentStandards"];
            this.isEditable = _data["isEditable"];
        }
    }

    static fromJS(data: any): StandardDto {
        data = typeof data === 'object' ? data : {};
        let result = new StandardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identificator"] = this.identificator;
        data["code"] = this.code;
        data["efficiencyDate"] = this.efficiencyDate ? this.efficiencyDate.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["description"] = this.description;
        data["katalog"] = this.katalog;
        data["detailUrl"] = this.detailUrl;
        data["anotation"] = this.anotation;
        data["category"] = this.category;
        data["subsequentStandards"] = this.subsequentStandards;
        data["isEditable"] = this.isEditable;
        return data;
    }
}

export interface IStandardDto {
    id?: number;
    identificator?: string | undefined;
    code?: string | undefined;
    efficiencyDate?: Date;
    validTo?: Date | undefined;
    name?: string | undefined;
    description?: string | undefined;
    katalog?: string | undefined;
    detailUrl?: string | undefined;
    anotation?: string | undefined;
    category?: string | undefined;
    subsequentStandards?: string | undefined;
    isEditable?: boolean;
}

export class Stream implements IStream {
    readonly canRead?: boolean;
    readonly canWrite?: boolean;
    readonly canSeek?: boolean;
    readonly canTimeout?: boolean;
    readonly length?: number;
    position?: number;
    readTimeout?: number;
    writeTimeout?: number;

    constructor(data?: IStream) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).canRead = _data["canRead"];
            (<any>this).canWrite = _data["canWrite"];
            (<any>this).canSeek = _data["canSeek"];
            (<any>this).canTimeout = _data["canTimeout"];
            (<any>this).length = _data["length"];
            this.position = _data["position"];
            this.readTimeout = _data["readTimeout"];
            this.writeTimeout = _data["writeTimeout"];
        }
    }

    static fromJS(data: any): Stream {
        data = typeof data === 'object' ? data : {};
        let result = new Stream();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canRead"] = this.canRead;
        data["canWrite"] = this.canWrite;
        data["canSeek"] = this.canSeek;
        data["canTimeout"] = this.canTimeout;
        data["length"] = this.length;
        data["position"] = this.position;
        data["readTimeout"] = this.readTimeout;
        data["writeTimeout"] = this.writeTimeout;
        return data;
    }
}

export interface IStream {
    canRead?: boolean;
    canWrite?: boolean;
    canSeek?: boolean;
    canTimeout?: boolean;
    length?: number;
    position?: number;
    readTimeout?: number;
    writeTimeout?: number;
}

export class UpdateStandardsManuallyRequest implements IUpdateStandardsManuallyRequest {
    id?: number;
    identificator?: string | undefined;
    code?: string | undefined;
    efficiencyDate?: Date;
    validTo?: Date | undefined;
    name?: string | undefined;
    description?: string | undefined;
    detailUrl?: string | undefined;
    anotation?: string | undefined;
    subsequentStandards?: string | undefined;

    constructor(data?: IUpdateStandardsManuallyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identificator = _data["identificator"];
            this.code = _data["code"];
            this.efficiencyDate = _data["efficiencyDate"] ? new Date(_data["efficiencyDate"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.description = _data["description"];
            this.detailUrl = _data["detailUrl"];
            this.anotation = _data["anotation"];
            this.subsequentStandards = _data["subsequentStandards"];
        }
    }

    static fromJS(data: any): UpdateStandardsManuallyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStandardsManuallyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identificator"] = this.identificator;
        data["code"] = this.code;
        data["efficiencyDate"] = this.efficiencyDate ? this.efficiencyDate.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["description"] = this.description;
        data["detailUrl"] = this.detailUrl;
        data["anotation"] = this.anotation;
        data["subsequentStandards"] = this.subsequentStandards;
        return data;
    }
}

export interface IUpdateStandardsManuallyRequest {
    id?: number;
    identificator?: string | undefined;
    code?: string | undefined;
    efficiencyDate?: Date;
    validTo?: Date | undefined;
    name?: string | undefined;
    description?: string | undefined;
    detailUrl?: string | undefined;
    anotation?: string | undefined;
    subsequentStandards?: string | undefined;
}

export class UpdateStandardsManuallyResponse implements IUpdateStandardsManuallyResponse {
    ok?: boolean;
    id?: number;

    constructor(data?: IUpdateStandardsManuallyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateStandardsManuallyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStandardsManuallyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateStandardsManuallyResponse {
    ok?: boolean;
    id?: number;
}

export class ValidStandard implements IValidStandard {
    id?: number;
    identificator?: string | undefined;
    name?: string | undefined;
    validFrom?: string | undefined;
    detailUrl?: string | undefined;
    anotation?: string | undefined;
    description?: string | undefined;
    replace?: boolean;

    constructor(data?: IValidStandard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identificator = _data["identificator"];
            this.name = _data["name"];
            this.validFrom = _data["validFrom"];
            this.detailUrl = _data["detailUrl"];
            this.anotation = _data["anotation"];
            this.description = _data["description"];
            this.replace = _data["replace"];
        }
    }

    static fromJS(data: any): ValidStandard {
        data = typeof data === 'object' ? data : {};
        let result = new ValidStandard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identificator"] = this.identificator;
        data["name"] = this.name;
        data["validFrom"] = this.validFrom;
        data["detailUrl"] = this.detailUrl;
        data["anotation"] = this.anotation;
        data["description"] = this.description;
        data["replace"] = this.replace;
        return data;
    }
}

export interface IValidStandard {
    id?: number;
    identificator?: string | undefined;
    name?: string | undefined;
    validFrom?: string | undefined;
    detailUrl?: string | undefined;
    anotation?: string | undefined;
    description?: string | undefined;
    replace?: boolean;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}